// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.egLIzDRZbnzj7eNcXM0p{padding:4px}.GbBrVhqGz_5Wijvpycoo{padding:8px 12px}`, "",{"version":3,"sources":["webpack://./src/widgets/AIAssistant/ui/AIAssistantContent/InitContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CAGF,sBACE,gBAAA","sourcesContent":[".wrap{\n  padding: 4px;\n}\n\n.title {\n  padding: 8px 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `egLIzDRZbnzj7eNcXM0p`,
	"title": `GbBrVhqGz_5Wijvpycoo`
};
export default ___CSS_LOADER_EXPORT___;
